import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { BackEndApiType } from '../configuration/backend-api-type';
import { MessageBusService, MessageBusType } from '../message-bus/message-bus.service';
import { AdditionalLoginProvider, AdditionalLoginResponse, AdditionalLoginResult, EpoUser, UserSession } from './authentication.interfaces';

export const epoSessionStorageKey = 'userCredentials';
export const epoDatabaseIdStorageKey = 'databaseId';
export const epoServerAddressStorageKey = 'serverIP';

/**
 * EPO authentication
 */
@Injectable({
	providedIn: 'root',
	deps: [HttpClient, MessageBusService],
})
export class EpoAuthenticationProvider implements AdditionalLoginProvider {
	backendType: BackEndApiType = BackEndApiType.Evolution;

	/**
	 *
	 */
	constructor(private http: HttpClient, private msgBus: MessageBusService) {}

	beforeLogin(userSession: UserSession, alr: AdditionalLoginResponse) {
		// For epo we want agent name as displayName
		//userSession.user.displayName = alr.agentName;

		// For EPO, the session should be stored
		if (alr.apiType === BackEndApiType.Evolution) {
			// EPO is reading the 'guid' for setting the token in API requests, don't remove!
			localStorage.setItem(
				epoSessionStorageKey,
				JSON.stringify({
					id: 1,
					guid: alr.token,
					supplierID: alr.supplierId,
					userId: alr.evolutionUserId,
					username: alr.agentName || userSession.user.userName,
				})
			);
			localStorage.setItem(epoDatabaseIdStorageKey, JSON.stringify(alr.databaseId));
			localStorage.setItem(
				epoServerAddressStorageKey,
				JSON.stringify({
					id: alr.serverId,
					name: alr.name,
					address: alr.serverUrl,
					apiType: BackEndApiType.Evolution,
				})
			);
		}
	}

	getUserData(alr: AdditionalLoginResponse): Observable<AdditionalLoginResult> {
		const headers = new HttpHeaders({
			guid: alr.token,
		});

		return this.http.get(`${alr.serverUrl}UserLogin/CheckInSession`, { headers }).pipe(
			map((user: EpoUser) => {
				const result: AdditionalLoginResult = {
					type: BackEndApiType.Evolution,
					success: user.isForeign === false,
					user,
				};

				return result;
			}),
			tap(authResult => {
				if (authResult.success) {
					// this.sync.clearCache();
					this.msgBus.emit({ type: MessageBusType.EPO, subType: 'clearCache', payload: true });
				}
			})
		);
	}

	refreshToken(): boolean {
		throw new Error('Method not implemented.');
	}

	logoff(): void {
		this.clearEpoData();
	}

	/**
	 * Clear epo data
	 */
	clearEpoData() {
		localStorage.removeItem(epoServerAddressStorageKey);
		localStorage.removeItem(epoDatabaseIdStorageKey);
		localStorage.removeItem(epoSessionStorageKey);
	}
}
